import { useEffect, useState } from 'react'
import { useRemoteClientGet, useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'

export const loadTemplates = (page: number = 0) => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const { getUnitId } = useLocalStorage()

  const { httpClientPost } = useRemoteClientPost()
  const reloadTemplates = () => load(0)

  const load = (setPage?: number) => {
    if (!loading) {
      setLoading(true)
      httpClientPost(`/contratos/filtro?page=${setPage || page}&size=10`, {
        idUnidade: getUnitId()
      })
        .then(setData)
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    load()
  }, [page])

  return {
    load,
    reloadTemplates,
    data
  }
}

export const loadTemplate = (id: string | number) => {
  const { getUnitId } = useLocalStorage()
  const { remoteClientGet } = useRemoteClientGet()
  return remoteClientGet('/contratos/' + id, {
    idUnidade: getUnitId()
  })
}
